import { NgModule, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // For ngModel
import { Router, RouterModule } from '@angular/router';
// import { Component, ElementRef, ViewChild } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { HttpClient } from '@angular/common/http';

import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { ConfirmationService, MessageService } from 'primeng/api';
import { Table, TableModule } from 'primeng/table';
import { ProductService } from '../pages/service/product.service';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { RatingModule } from 'primeng/rating';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
// import { Product, ProductService } from '../service/product.service';
import { Location } from '@angular/common';
import { UserService } from '../pages/service/user.service'; // <-- Import UserService
import { getPersistedItemDetailsVersion, itemDetailsRouteCommands } from '../item-details/item-details-routing.util';
import { MenuItem } from 'primeng/api';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu'; // ✅ Import this
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { environment } from '../../environments/environment';
import { LoaderService } from '../services/loader.service';
import { timeout } from 'rxjs';
@Component({
    selector: 'app-generate-invoice',
    imports: [
        AutoCompleteModule,
        // AppTopbar,
        RouterModule,
        CommonModule,
        TableModule,
        FormsModule,
        ButtonModule,
        ContextMenuModule,
        RippleModule,
        ToastModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule
    ],
    templateUrl: './generate-invoice.component.html',
    styleUrl: './generate-invoice.component.scss',
    providers: [ConfirmationService, MessageService] // <-- Add providers here
})
export class GenerateInvoiceComponent implements OnInit, OnDestroy {
    item: any;
    readonly a4HeightPx = 1122; // A4 height in pixels at 96dpi
    @ViewChild('header') headerRef!: ElementRef;
    @ViewChild('footer') footerRef!: ElementRef;
    @ViewChild('summaryDiv') summaryRef!: ElementRef;
    @ViewChild('itemsTable') itemsTableRef!: ElementRef;
    @ViewChild('mainContent') mainContentRef!: ElementRef;
    isPreviewMode: boolean = false;
    isFromSyncFlow: boolean = false;
    itemList: any[] = [];
    totalAmountAfterDiscount = 0;
    @ViewChild('invoice') invoiceElement!: ElementRef;
    paginatedContent: any[][] = [];
    // Add base64 data property
    invoiceBase64Data: string = '';
    invoicePdfUrl: SafeResourceUrl = '';
    private invoiceObjectUrl: string | null = null;
    invoiceDataLoaded: boolean = false;

    // Invoice in progress (IDM not ready): dialog + auto-retry
    invoiceInProgressDialogVisible = false;
    invoiceInProgressAttempt = 0;
    invoiceInProgressCountdown = 15;
    invoiceInProgressIntervalId: ReturnType<typeof setInterval> | null = null;
    invoiceInProgressFinalMessage: string | null = null;
    private invoiceInProgressParams: { orderNumber: string; companyId: string; divisionId: string; isPreview: boolean } | null = null;
    supplierDetails = {
        supplerVrno: '',
        coa1: '',
        phno: '',
        coa2: '',
        coa3: '',
        coa4: ''
    };
    customerDetails = {
        customerVrno: '',
        CUA1: '',
        CUA2: '',
        CUA3: '',
        CUA4: '',
        phoneNumber: ''
    };
    invoiceDetails = {
        invoiceNo: '',
        customerNo: '',
        date: '',
        orderNumber: '',
        referenceOrderNumber: ''
    };
    threshold: number = 10; // <-- Add this line
    lineDetails: any[] = [];
    // Pagination: variable items per page based on wrapped description lines
    private readonly PAGE_LINE_BUDGET = 24;
    private readonly DESC_CHARS_PER_LINE = 30;
    private readonly SUMMARY_RESERVED_LINES = 6;
    /** Print-only: safer budget so wrapped descriptions are not clipped by overflow. */
    private readonly PRINT_PAGE_LINE_BUDGET = 24;
    private readonly PRINT_DESC_CHARS_PER_LINE = 28;
    private readonly PRINT_SAFETY_ROWS = 2;
    ngAfterViewInit() {
        setTimeout(() => {
            const headerHeight = this.headerRef?.nativeElement.offsetHeight || 0;
            const footerHeight = this.footerRef?.nativeElement.offsetHeight || 0;
            const summaryHeight = this.summaryRef?.nativeElement.offsetHeight || 0;
            const itemsTableHeight = this.itemsTableRef?.nativeElement.offsetHeight || 0;
            const mainContentHeight = this.mainContentRef?.nativeElement.offsetHeight || 0;
            const totalContentHeight = headerHeight + footerHeight + summaryHeight + itemsTableHeight + mainContentHeight;

            console.log('Header height:', headerHeight, 'px');
            console.log('Footer height:', footerHeight, 'px');
            console.log('Summary height:', summaryHeight, 'px');
            console.log('Items table height:', itemsTableHeight, 'px');
            console.log('Total content height:', totalContentHeight, 'px');
            console.log('Main content height:', mainContentHeight, 'px');
            console.log('A4 page height:', this.a4HeightPx, 'px');
            if (totalContentHeight > this.a4HeightPx) {
                console.warn('Content exceeds A4 page height!');
            } else {
                console.info('Content fits within A4 page height.');
            }
        }, 500); // Wait for DOM to render
    }
    summaryOnExtraPage: boolean = false; // Already present
    summary = {
        grossValue: 0,
        totalDiscountValue: 0,
        netAmount: 0,
        vatAmount: 0,
        totalOrderValue: 0,
        totalGrossWeight: 0,
        vatPercent: 0,
        taxBase: 0,
        vatSummaries: [] as { vatPercentage: number; totalNetAmount: number; totalVatAmount: number }[]
    };
    skipReleaseLock = false;
    confirmInvoiceDialogVisible = false;
    private getRowLineCost(line: any): number {
        const desc = (line?.description ?? '').toString();
        const len = desc.length;
        const lines = Math.ceil(Math.max(1, len) / this.DESC_CHARS_PER_LINE);
        return Math.max(1, lines);
    }

    private paginateByWrappedLines(lines: any[]): { pages: any[][]; summaryOnExtraPage: boolean } {
        const pages: any[][] = [];
        let current: any[] = [];
        let used = 0;

        for (const line of (lines || [])) {
            const cost = this.getRowLineCost(line);
            if (current.length > 0 && used + cost > this.PAGE_LINE_BUDGET) {
                pages.push(current);
                current = [];
                used = 0;
            }
            current.push(line);
            used += cost;
        }

        if (pages.length === 0 || current.length > 0) {
            pages.push(current);
        }

        const lastPage = pages[pages.length - 1] || [];
        const lastUsed = lastPage.reduce((sum, l) => sum + this.getRowLineCost(l), 0);
        const remaining = this.PAGE_LINE_BUDGET - lastUsed;
        const summaryOnExtraPage = remaining < this.SUMMARY_RESERVED_LINES;

        return { pages, summaryOnExtraPage };
    }

    private getPrintRowLineCost(line: any): number {
        const desc = (line?.description ?? '').toString().trim();
        if (!desc) {
            return 1;
        }
        return Math.min(3, Math.max(1, Math.ceil(desc.length / this.PRINT_DESC_CHARS_PER_LINE)));
    }

    /** Print-only pagination with safety margin; preview keeps paginateByWrappedLines. */
    private paginateForPrint(lines: any[]): { pages: any[][]; summaryOnExtraPage: boolean } {
        const pages: any[][] = [];
        let current: any[] = [];
        let used = 0;
        const maxUsed = this.PRINT_PAGE_LINE_BUDGET - this.PRINT_SAFETY_ROWS;

        for (const line of lines || []) {
            const cost = this.getPrintRowLineCost(line);
            if (current.length > 0 && used + cost > maxUsed) {
                pages.push(current);
                current = [];
                used = 0;
            }
            current.push(line);
            used += cost;
        }

        if (pages.length === 0 || current.length > 0) {
            pages.push(current);
        }

        const lastPage = pages[pages.length - 1] || [];
        const lastUsed = lastPage.reduce((sum, l) => sum + this.getPrintRowLineCost(l), 0);
        const remaining = maxUsed - lastUsed;
        const summaryOnExtraPage = remaining < this.SUMMARY_RESERVED_LINES;

        return { pages, summaryOnExtraPage };
    }

    private applyPrintPaginationForCapture(): { savedPages: any[][]; savedSummary: boolean } {
        const savedPages = this.paginatedContent;
        const savedSummary = this.summaryOnExtraPage;
        const printPaginated = this.paginateForPrint(this.lineDetails);
        this.paginatedContent = printPaginated.pages;
        this.summaryOnExtraPage = printPaginated.summaryOnExtraPage;
        this.cdr.detectChanges();
        return { savedPages, savedSummary };
    }

    private restorePrintPagination(savedPages: any[][], savedSummary: boolean): void {
        this.paginatedContent = savedPages;
        this.summaryOnExtraPage = savedSummary;
        this.cdr.detectChanges();
    }

    private rewriteRelativeAssetUrls(html: string): string {
        const baseHref =
            document.querySelector('base')?.href ||
            `${window.location.origin}${window.location.pathname.replace(/\/[^/]*$/, '/')}`;
        return html.replace(/(src=["'])(?!https?:|data:|blob:)([^"']+)/gi, (_m, prefix: string, path: string) => {
            try {
                return prefix + new URL(path, baseHref).href;
            } catch {
                return prefix + path;
            }
        });
    }

    divisionId: string = ''; // <-- Add this line
    div1: string = '';
    constructor(
        private http: HttpClient,
        private router: Router,
        private userService: UserService,
        private location: Location,
        private messageService: MessageService,
        private loaderService: LoaderService,
        private productService: ProductService,
        private confirmationService: ConfirmationService,
        private sanitizer: DomSanitizer,
        private cdr: ChangeDetectorRef

    ) {
        // <-- Inject UserService
        const nav = this.router.getCurrentNavigation();
        const state = nav?.extras?.state as any;
        this.item = state?.item;
        this.itemList = state?.itemList || [];
    }

    private revokeInvoiceObjectUrl() {
        if (this.invoiceObjectUrl) {
            URL.revokeObjectURL(this.invoiceObjectUrl);
            this.invoiceObjectUrl = null;
        }
    }

    private base64ToBlob(base64: string, mime: string = 'application/pdf'): Blob {
        const cleaned = base64.replace(/\s/g, '');
        const binary = atob(cleaned);
        const len = binary.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return new Blob([bytes], { type: mime });
    }

    private extractInvoiceNumber(response: any): string {
        if (!response) return '';
        if (typeof response === 'string') return response.trim();
        if (typeof response === 'object') {
            return (
                response.invoiceNumber ||
                response.invoiceNo ||
                response.invoice ||
                response.number ||
                ''
            )
                .toString()
                .trim();
        }
        return '';
    }

    private isLegacyInvoice(invoiceNumber: string): boolean {
        return invoiceNumber.toUpperCase().startsWith('INV');
    }
    goBack() {
        this.skipReleaseLock = false; // Set flag to skip lock release
        // if (window.history.length > 1) {
        //     this.location.back();
        // } else {
        this.router.navigate(['/Orders1']);
        // }
    }

    goToOrder() {
        if (!this.item?.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Order number is required.'
            });
            return;
        }

        // Navigate to item details page with order number and state
        // Set flag to skip lock release since user is going to edit the order
        this.skipReleaseLock = true;
        const division = this.userService.getDivisionId() || this.item?.divisionId || '';
        const version = getPersistedItemDetailsVersion(division);
        this.router.navigate(itemDetailsRouteCommands(version, this.item.orderNumber), {
            state: {
                product: this.item,
                itemList: this.itemList
            }
        });
    }

    // Define the page height (adjust based on your layout)
    pageHeight: number = 1122; // example for A4 at 96dpi or adjust as needed
    lockRefreshInterval: any = null;
    // Track content height on the last page (to be calculated during rendering)
    lastPageContentHeight: number = 0;

    // Summary block height (can be updated dynamically or hardcoded after testing)
    summaryHeight: number = 200; // adjust based on actual summary height

    // Flag to indicate if the summary needs to go on an extra page

    ngOnInit() {
        this.startLockRefresh();
        // Get divisionId from navigation state or userService
        const divisionId = this.userService.getDivisionId() || this.item?.divisionId || '100';
        this.div1 = divisionId;

        // Set language based on division
        if (divisionId === '100') {
            this.selectedLanguage = 'de';
        } else if (divisionId === '400') {
            this.selectedLanguage = 'nl';
        } else if (divisionId === '300') {
            this.selectedLanguage = 'fr';
        } else {
            this.selectedLanguage = 'en';
        }

        this.threshold = 6;
        console.log('Selected Language:', this.selectedLanguage, 'Threshold:', this.threshold);

        // Remove all dummy data assignments
        console.log('Item:', this.item);
        console.log('Item List:', this.itemList);
        console.log(this.itemList.length, 'Item Length');

        console.log(this.lineDetails, 'Item Details');
        // Use itemList for pagination if lineDetails is null or empty
        const sourceList = this.lineDetails && this.lineDetails.length ? this.lineDetails : this.itemList;
        const paginated = this.paginateByWrappedLines(sourceList);
        this.paginatedContent = paginated.pages;
        this.summaryOnExtraPage = paginated.summaryOnExtraPage;

        // Example: get these from your navigation state or user service
        const orderNumber = this.item?.orderNumber;
        const companyId = this.userService.getCompanyId() || '';

        this.div1 = divisionId;
        console.log('Company ID:', companyId, 'Division ID:', divisionId, 'Order Number:', orderNumber);
        const navigation = this.router.getCurrentNavigation();
        const state = navigation?.extras?.state || history.state;
        
        if (state && state.item) {
            this.item = state.item;
            this.itemList = state.itemList || [];
            const companyId = this.userService.getCompanyId() || '';
            const divisionId = this.userService.getDivisionId() || '';
            console.log(state, 'state');
            console.log(state.isPreview, 'isPreview');

            
            
            const isPreview = state.isPreview || false;
            this.isFromSyncFlow = state.fromSync || false;
            console.log(this.isFromSyncFlow, 'isFromSyncFlow');
            console.log(this.isPreviewMode, 'isPreviewMode');
            this.fetchInvoiceData(this.item.orderNumber, companyId, divisionId, isPreview);  
        }

        // this.fetchInvoiceData(orderNumber, companyId, divisionId);
        
    }
    onLanguageChange(lang: string) {
        this.selectedLanguage = lang;
        // No pagination or summary logic here
    }

    // chunkData(data: any[], size: number): any[][] {
    //     const chunks = [];
    //     for (let i = 0; i < data.length; i += size) {
    //         chunks.push(data.slice(i, i + size));
    //     }
    //     // If the last chunk is "full", add an empty chunk for summary/footer
    //     if (chunks.length && chunks[chunks.length - 1].length === size) {
    //         chunks.push([]);
    //     }
    //     return chunks;
    // }

    formatBBE(dateStr: string): string {
        if (!dateStr || dateStr.length !== 8) return dateStr || '';
        return `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`;
    }

    getTotalAmountAfterDiscount(): number {
        return this.itemList.reduce((sum, item) => sum + item.amountAfterDiscount, 0);
    }
    getGrossValue(): number {
        return (this.itemList || []).reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
    }
    getTotalDiscountValue(): number {
        return (this.itemList || []).reduce((sum, row) => sum + ((Number(row.amount) * Number(row.discount)) / 100 || 0), 0);
    }
    getNetAmount(): number {
        return (this.itemList || []).reduce((sum, row) => sum + (Number(row.amountAfterDiscount) || 0), 0);
    }
    getVatAmount(): number {
        return (this.itemList || []).reduce((sum, row) => sum + (Number(row.vatAmount) || (Number(row.amountAfterDiscount) * Number(row.vat)) / 100 || 0), 0);
    }
    getOrderValue(): number {
        return this.getNetAmount() + this.getVatAmount();
    }

    printInvoice() {
        this.messageService.add({
            severity: 'success',
            summary: 'Printing Invoice',
            detail: 'Please wait while the invoice is being prepared for printing.',
            life: 1000
        });

        const { savedPages, savedSummary } = this.applyPrintPaginationForCapture();
        let printContents = this.rewriteRelativeAssetUrls(this.invoiceElement.nativeElement.innerHTML);
        this.restorePrintPagination(savedPages, savedSummary);

        const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
            .map((node) => node.outerHTML)
            .join('\n');

        let printTitle = 'Invoice';
        if (this.isPreviewMode) {
            const orderNumber = this.invoiceDetails?.orderNumber || this.item?.orderNumber || '';
            printTitle = orderNumber ? `Preview_${orderNumber}` : 'Preview';
        } else {
            const invoiceNo = this.invoiceDetails?.invoiceNo || '';
            printTitle = invoiceNo || 'Invoice';
        }

        const popupWin = window.open('', '_blank', 'width=1000,height=800');
        if (!popupWin) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Print blocked',
                detail: 'Please allow pop-ups for this site to print the invoice.',
                life: 5000
            });
            return;
        }
        popupWin.document.open();
        popupWin.document.write(`
      <html>
        <head>
          <title>${printTitle}</title>
          ${styles}
          <style>
            body { background: #fff !important; }
            .invoice-wrapper { box-shadow: none !important; border-radius: 0 !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }
         
            .p-toolbar, .p-button-sm, .p-button-secondary { display: none !important; }
            @media print {
              .invoice-wrapper { page-break-after: always; }
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
      </html>
    `);
        popupWin.document.close();
    }
    exportToPDF() {
        this.messageService.add({
            severity: 'success',
            summary: 'Exporting to PDF',
            detail: 'Please wait while the invoice is being prepared for PDF export.',
            life: 1000
        });

        const { savedPages, savedSummary } = this.applyPrintPaginationForCapture();
        const element = this.invoiceElement.nativeElement;
        element.classList.add('pdf-export');

        const wrappers: HTMLElement[] = Array.from(element.querySelectorAll('.invoice-wrapper'));
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const finishExport = () => {
            this.restorePrintPagination(savedPages, savedSummary);
            element.classList.remove('pdf-export');
        };

        const renderPage = (idx: number) => {
            if (idx >= wrappers.length) {
                let filename = 'Invoice.pdf';
                if (this.isPreviewMode) {
                    const orderNumber = this.invoiceDetails?.orderNumber || this.item?.orderNumber || '';
                    filename = orderNumber ? `Preview_${orderNumber}.pdf` : 'Preview.pdf';
                } else {
                    const invoiceNo = this.invoiceDetails?.invoiceNo || '';
                    filename = invoiceNo ? `${invoiceNo}.pdf` : 'Invoice.pdf';
                }
                pdf.save(filename);
                finishExport();
                return;
            }
            html2canvas(wrappers[idx], { scale: 2 }).then((canvas) => {
                const imgData = canvas.toDataURL('image/jpeg', 1.0);
                const imgProps = pdf.getImageProperties(imgData);
                const imgWidth = pageWidth;
                const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

                if (idx > 0) pdf.addPage();
                pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight > pageHeight ? pageHeight : imgHeight);

                renderPage(idx + 1);
            }).catch(() => {
                finishExport();
            });
        };

        renderPage(0);
    }


    private clearLegacyInvoiceState() {
        this.supplierDetails = {
            supplerVrno: '',
            coa1: '',
            phno: '',
            coa2: '',
            coa3: '',
            coa4: ''
        };
        this.customerDetails = {
            customerVrno: '',
            CUA1: '',
            CUA2: '',
            CUA3: '',
            CUA4: '',
            phoneNumber: ''
        };
        this.invoiceDetails = {
            invoiceNo: '',
            customerNo: '',
            date: '',
            orderNumber: '',
            referenceOrderNumber: ''
        };
        this.lineDetails = [];
        this.summary = {
            grossValue: 0,
            totalDiscountValue: 0,
            netAmount: 0,
            vatAmount: 0,
            totalOrderValue: 0,
            totalGrossWeight: 0,
            vatPercent: 0,
            taxBase: 0,
            vatSummaries: []
        };
        this.paginatedContent = [];
        this.summaryOnExtraPage = false;
    }

    private mapLegacyInvoicePayload(data: any) {
        this.supplierDetails = {
            supplerVrno: data?.supplierDetails?.vrno || '',
            coa1: data?.supplierDetails?.coa1 || '',
            phno: data?.supplierDetails?.phno || '',
            coa2: data?.supplierDetails?.coa2 || '',
            coa3: data?.supplierDetails?.coa3 || '',
            coa4: data?.supplierDetails?.coa4 || ''
        };

        this.customerDetails = {
            customerVrno: data?.customerDetails?.customerVrno || '',
            CUA1: data?.customerDetails?.customerAddress || '',
            CUA2: '',
            CUA3: '',
            CUA4: '',
            phoneNumber: data?.customerDetails?.phoneNumber || ''
        };

        this.invoiceDetails = {
            invoiceNo: data?.invoiceDetails?.invoiceNo || '',
            customerNo: data?.invoiceDetails?.customerNo || '',
            date: data?.invoiceDetails?.date || '',
            orderNumber: data?.invoiceDetails?.orderNumber || '',
            referenceOrderNumber: data?.invoiceDetails?.referenceOrderId || ''
        };

        this.lineDetails = (data?.lineDetails || []).map((line: any) => ({
            position: line.lineNo,
            itemNo: line.itemNo,
            quantity: line.quantity,
            description: line.description,
            size: line.size || '',
            pcs: line.pcs,
            ppuEUR: line.salesPrice,
            discountPercent: line.discountPercent,
            lineAmount: line.lineAmount,
            vatCode: line.vatPerc === 0 ? '0' : line.vatCode,
            grossWeight: line.grossWeight
        }));

        const paginated = this.paginateByWrappedLines(this.lineDetails);
        this.paginatedContent = paginated.pages;
        this.summaryOnExtraPage = paginated.summaryOnExtraPage;

        this.summary = {
            grossValue: data?.summaryLevelData?.grossValue || 0,
            totalDiscountValue: data?.summaryLevelData?.totalDiscountValue || 0,
            netAmount: data?.summaryLevelData?.netAmount || 0,
            vatAmount: data?.summaryLevelData?.vatAmount || 0,
            totalOrderValue: data?.summaryLevelData?.orderValue || 0,
            totalGrossWeight: Math.round((Number(data?.summaryLevelData?.totalGrossWeight) || 0) * 100) / 100,
            vatPercent: data?.summaryLevelData?.vatPercent || 0,
            taxBase: data?.summaryLevelData?.taxBase || 0,
            vatSummaries: data?.summaryLevelData?.vatSummaries || []
        };
    }
    fetchInvoiceData(orderNumber: string, companyId: string, divisionId: string, isPreview: boolean = false) {
        this.isPreviewMode = isPreview;
        this.loaderService.show(isPreview ? 'Generating Preview' : 'Fetching Invoice Data', 'Please wait...');

        const invoiceNumberUrl = `${environment.apiUrl}m3/invoice/number?orderNumber=${orderNumber}&company=${companyId}&division=${divisionId}`;
        this.http.get<any>(invoiceNumberUrl).subscribe({
            next: (numberResponse) => {
                const invoiceNumber = this.extractInvoiceNumber(numberResponse);
                if (this.isLegacyInvoice(invoiceNumber)) {
                    this.fetchLegacyInvoiceData(orderNumber, companyId, divisionId, isPreview);
                    return;
                }
                this.fetchM3InvoiceData(orderNumber, companyId, divisionId, isPreview);
            },
            error: (lookupError) => {
                console.warn('Invoice number lookup failed. Falling back to M3 invoice API.', lookupError);
                this.fetchM3InvoiceData(orderNumber, companyId, divisionId, isPreview);
            }
        });
    }

    private fetchLegacyInvoiceData(orderNumber: string, companyId: string, divisionId: string, isPreview: boolean) {
        const status = isPreview ? 'PREVIEW' : 'INV';
        const legacyUrl = `${environment.apiUrl}InvoiceAndPicklist/generateOutput?companyId=${companyId}&divisionId=${divisionId}&orderNumber=${orderNumber}&orderMovingStatus=${status}`;

        this.http.get<any>(legacyUrl).subscribe({
            next: (data) => {
                setTimeout(() => {
                    this.loaderService.hide();
                }, 300);

                this.revokeInvoiceObjectUrl();
                this.invoiceDataLoaded = false;
                this.invoiceBase64Data = '';
                this.mapLegacyInvoicePayload(data);

                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Invoice loaded successfully.'
                });
            },
            error: (error) => {
                this.loaderService.hide();
                console.error('Error loading legacy invoice data:', error);
                this.clearLegacyInvoiceState();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load invoice data.'
                });
            }
        });
    }

    private fetchM3InvoiceData(orderNumber: string, companyId: string, divisionId: string, isPreview: boolean) {
        const baseUrl = `${environment.apiUrl}m3/invoice/base64`;
        const url = `${baseUrl}?orderNumber=${orderNumber}&company=${companyId}&division=${divisionId}`;

        this.http.get(url, { responseType: 'text' }).subscribe({
            next: (response) => {
                setTimeout(() => {
                    this.loaderService.hide();
                }, 300);

                const base64 = response?.trim();
                if (!base64) {
                    this.invoiceDataLoaded = false;
                    this.invoiceBase64Data = '';
                    this.revokeInvoiceObjectUrl();
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'No invoice',
                        detail: 'No invoice data was returned for this order.'
                    });
                    return;
                }

                try {
                    this.clearLegacyInvoiceState();
                    this.revokeInvoiceObjectUrl();
                    const blob = this.base64ToBlob(base64, 'application/pdf');
                    const objectUrl = URL.createObjectURL(blob);
                    this.invoiceObjectUrl = objectUrl;
                    this.invoiceBase64Data = base64;
                    this.invoicePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
                    this.invoiceDataLoaded = true;

                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Invoice loaded successfully.'
                    });
                } catch (e) {
                    console.error('Failed to decode/render invoice PDF from base64:', e);
                    this.invoiceDataLoaded = false;
                    this.invoiceBase64Data = '';
                    this.revokeInvoiceObjectUrl();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Invoice error',
                        detail: 'Invoice data was received but could not be rendered. Please try again or download from M3.'
                    });
                }
            },
            error: (error) => {
                this.loaderService.hide();
                console.error('Error loading M3 invoice data:', error);
                if (this.isInvoiceInProgressError(error)) {
                    this.openInvoiceInProgressDialog(orderNumber, companyId, divisionId, isPreview);
                    return;
                }
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load invoice data.'
                });
            }
        });
    }

    private isInvoiceInProgressError(error: any): boolean {
        try {
            const body = typeof error?.error === 'string' ? JSON.parse(error.error) : error?.error;
            const msg = (body?.message ?? '').toString();
            return msg.includes('PID not found in IDM') || msg.includes('Error while fetching invoice from IDM');
        } catch {
            return false;
        }
    }

    private openInvoiceInProgressDialog(orderNumber: string, companyId: string, divisionId: string, isPreview: boolean) {
        this.invoiceInProgressParams = { orderNumber, companyId, divisionId, isPreview };
        this.invoiceInProgressAttempt = 1;
        this.invoiceInProgressCountdown = 15;
        this.invoiceInProgressFinalMessage = null;
        this.invoiceInProgressDialogVisible = true;
        this.startInvoiceInProgressCountdown();
    }

    closeInvoiceInProgressDialog() {
        if (this.invoiceInProgressIntervalId != null) {
            clearInterval(this.invoiceInProgressIntervalId);
            this.invoiceInProgressIntervalId = null;
        }
        this.invoiceInProgressDialogVisible = false;
        this.invoiceInProgressFinalMessage = null;
        this.invoiceInProgressParams = null;
    }

    closeInvoiceInProgressAndGoBack() {
        this.closeInvoiceInProgressDialog();
        this.goBack();
    }

    private startInvoiceInProgressCountdown() {
        if (this.invoiceInProgressFinalMessage) {
            return;
        }
        if (this.invoiceInProgressIntervalId != null) {
            clearInterval(this.invoiceInProgressIntervalId);
        }
        this.invoiceInProgressCountdown = 15;
        this.invoiceInProgressIntervalId = setInterval(() => {
            this.invoiceInProgressCountdown--;
            if (this.invoiceInProgressCountdown <= 0) {
                if (this.invoiceInProgressIntervalId != null) {
                    clearInterval(this.invoiceInProgressIntervalId);
                    this.invoiceInProgressIntervalId = null;
                }
                this.retryInvoiceFetch();
            }
        }, 1000);
    }

    retryInvoiceFetch() {
        if (this.invoiceInProgressIntervalId != null) {
            clearInterval(this.invoiceInProgressIntervalId);
            this.invoiceInProgressIntervalId = null;
        }
        if (this.invoiceInProgressFinalMessage) {
            return;
        }
        const p = this.invoiceInProgressParams;
        if (!p) return;
        if (this.invoiceInProgressAttempt >= 5) {
            this.invoiceInProgressFinalMessage =
                'There seems to be an issue generating the invoice. Please try to Download the invoice from M3.';
            return;
        }
        this.invoiceInProgressAttempt++;
        const baseUrl = `${environment.apiUrl}m3/invoice/base64`;
        const url = `${baseUrl}?orderNumber=${p.orderNumber}&company=${p.companyId}&division=${p.divisionId}`;
        this.http.get(url, { responseType: 'text' }).subscribe({
            next: (response) => {
                if (this.invoiceInProgressIntervalId != null) {
                    clearInterval(this.invoiceInProgressIntervalId);
                    this.invoiceInProgressIntervalId = null;
                }
                this.invoiceInProgressDialogVisible = false;
                this.invoiceInProgressParams = null;

                const base64 = response?.trim();
                if (!base64) {
                    this.invoiceDataLoaded = false;
                    this.invoiceBase64Data = '';
                    this.revokeInvoiceObjectUrl();
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'No invoice',
                        detail: 'No invoice data was returned for this order.'
                    });
                    return;
                }

                try {
                    this.revokeInvoiceObjectUrl();
                    const blob = this.base64ToBlob(base64, 'application/pdf');
                    const objectUrl = URL.createObjectURL(blob);
                    this.invoiceObjectUrl = objectUrl;
                    this.invoiceBase64Data = base64;
                    this.invoicePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
                    this.invoiceDataLoaded = true;
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Invoice loaded successfully.'
                    });
                } catch (e) {
                    console.error('Failed to decode/render invoice PDF from base64 (retry):', e);
                    this.invoiceDataLoaded = false;
                    this.invoiceBase64Data = '';
                    this.revokeInvoiceObjectUrl();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Invoice error',
                        detail: 'Invoice data was received but could not be rendered. Please try again or download from M3.'
                    });
                }
            },
            error: (error) => {
                if (this.isInvoiceInProgressError(error) && this.invoiceInProgressAttempt < 5) {
                    this.startInvoiceInProgressCountdown();
                    return;
                }
                if (this.invoiceInProgressAttempt >= 5 && this.isInvoiceInProgressError(error)) {
                    this.invoiceInProgressFinalMessage =
                        'There seems to be an issue generating the invoice. Please try to generate the invoice directly in M3 and then try again here.';
                    return;
                }
                this.closeInvoiceInProgressDialog();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load invoice data.'
                });
            }
        });
    }

    selectedLanguage = 'en'; // default

    labels: { [lang: string]: { [key: string]: string } } = {
        en: {
            invoiceTitle: 'Invoice',
            invoiceNo: 'Invoice no.',
            customerNo: 'Customer no.',
            date: 'Date',
            orderNumber: 'Order number',
            referenceOrderNumber: 'Reference Order ID',
            position: 'No',
            itemNo: 'Item No',
            quantity: 'Quantity',
            description: 'Item Name',
            size: 'Size',
            pcs: 'Pcs',
            price: 'Rate',
            discount: 'Disc',
            amount: 'Total Amount',
            vatCode: 'VAT Code',
            grossValue: 'Gross Value',
            totalDiscountValue: 'Total Discount Value',
            netAmount: 'Net Amount',
            vatAmount: 'VAT Amount',
            orderValue: 'Order Value',
            supplierIdentNo: 'Supplier Ident No:',
            customerIdentNo: 'Customer Ident No:',
            grossWeight: 'Gross Weight:',
            vatCodeLabel: 'Code',
            vatPercentLabel: 'VAT %',
            taxBaseLabel: 'Tax Base',
            vatAmountLabel: 'VAT Amount'
        },
        de: {
            invoiceTitle: 'Rechnung',
            invoiceNo: 'Rechn.Nr.',
            customerNo: 'Kunden-Nr.',
            date: 'Datum',
            orderNumber: 'Auftragsnr.',
            referenceOrderNumber: 'Referenznr.',
            position: 'Pos',
            itemNo: 'ArtNr',
            quantity: 'Menge',
            description: 'Bezeichnung',
            size: 'Inhalt',
            pcs: 'Stk',
            price: 'Preis',
            discount: 'Rabatt',
            amount: 'Endbetrag',
            vatCode: 'MwSt Code',
            grossValue: 'Bruttowert',
            totalDiscountValue: 'Gesamtrabattwert',
            netAmount: 'Nettobetrag',
            vatAmount: 'Mehrwertsteuerbetrag',
            orderValue: 'Gesamtbetrag',
            supplierIdentNo: 'Lieferanten Ident Nr:',
            customerIdentNo: 'Klant Ident Nr:',
            grossWeight: 'Brutto Gewicht:',
            vatCodeLabel: 'Code',
            vatPercentLabel: 'MwSt %',
            taxBaseLabel: 'Grondslag',
            vatAmountLabel: 'MwSt-Betrag',
            preview: 'Preview'
        },
        nl: {
            invoiceTitle: 'Factuur',
            invoiceNo: 'Factuurnr.',
            customerNo: 'Klantnr.',
            date: 'Datum',
            orderNumber: 'Ordernr.',
            referenceOrderNumber: 'Referentie Ordernr.',
            position: 'sr.nr',
            itemNo: 'Artikel<br>nummer',
            quantity: 'Hoeveelheid',
            description: 'Omschrijving',
            size: 'Inhoud',
            pcs: 'Stuks',
            price: 'Prijs',
            discount: 'Korting',
            amount: 'Eindbedrag',
            vatCode: 'BTW Code',
            grossValue: 'Brutowaarde',
            totalDiscountValue: 'Totale korting',
            netAmount: 'Netto bedrag',
            vatAmount: 'BTW-bedrag',
            orderValue: 'Totaalbedrag',
            supplierIdentNo: 'Leverancier Ident Nr:',
            customerIdentNo: 'Klant Ident Nr:',
            grossWeight: 'Bruto gewicht:',
            vatCodeLabel: 'Code',
            vatPercentLabel: 'BTW %',
            taxBaseLabel: 'Grondslag',
            vatAmountLabel: 'BTW-bedrag',
            preview: 'Preview'
        },
        fr: {
            invoiceTitle: 'Facture',
            invoiceNo: 'N° facture',
            customerNo: 'N° client',
            date: 'Date',
            orderNumber: 'N° commande',
            referenceOrderNumber: 'N° commande de référence',
            position: 'N°',
            itemNo: 'N°<br>article',
            quantity: 'Quantité',
            description: 'Désignation',
            size: 'Contenu',
            pcs: 'Pcs',
            price: 'Prix',
            discount: 'Remise',
            amount: 'Montant total',
            vatCode: 'Code TVA',
            grossValue: 'Valeur brute',
            totalDiscountValue: 'Remise totale',
            netAmount: 'Montant net',
            vatAmount: 'Montant TVA',
            orderValue: 'Montant total',
            supplierIdentNo: 'N° ident. fournisseur :',
            customerIdentNo: 'N° ident. client :',
            grossWeight: 'Poids brut :',
            vatCodeLabel: 'Code',
            vatPercentLabel: 'TVA %',
            taxBaseLabel: 'Base imposable',
            vatAmountLabel: 'Montant TVA',
            preview: 'Aperçu'
        }
    };
    get headerImage(): string {
        switch (this.div1) {
          case '400': return 'assets/Header.jpg';
          case '300': return 'assets/header_FR.jpg';
          case '100': return 'assets/header_DE.jpg';
          default: return 'assets/Header.jpg';
        }
      }
    get footerImage(): string {
        switch (this.div1) {
          case '400':
            return 'assets/Footer.jpg';
          case '300':
            return 'assets/footer_FR.jpg';
          case '100':
            return 'assets/footer_DE.jpg';
          default:
            return 'assets/Footer.jpg'; // fallback
        }
      }
    confirmAndInvoice() {
        if (!this.item?.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Order number is required.'
            });
            return;
        }
        this.confirmInvoiceDialogVisible = true;
    }

    confirmAndGenerateInvoice() {
        this.confirmInvoiceDialogVisible = false;
        const companyId = this.userService.getCompanyId() || '';
        const divisionId = this.userService.getDivisionId() || '';
        this.loaderService.show('Invoicing Order', 'Please wait...');
        this.fetchInvoiceData(this.item.orderNumber, companyId, divisionId, false);
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Order has been invoiced successfully.'
        });
    }
    confirmSyncToM3() {
        const customerId = this.item?.customerId || this.invoiceDetails?.customerNo || this.item?.customer || '';
        const companyId = this.userService.getCompanyId() || this.item?.companyId || '';
        const divisionId = this.userService.getDivisionId() || this.item?.divisionId || '';
        this.loaderService.show('Checking customer status...', 'Please wait...');
        this.productService.checkCustomerBlock(customerId, companyId, divisionId).subscribe({
            next: (blockCheck) => {
                this.loaderService.hide();
                if (!blockCheck?.allowed) {
                    this.customerBlockedDialogMessage =
                        blockCheck?.message ||
                        `Customer ${blockCheck?.cuno || customerId} is blocked in M3 (block code ${blockCheck?.blcd || 'n/a'}). Sync is not allowed until the customer block is cleared.`;
                    this.customerBlockedDialogVisible = true;
                    return;
                }
                const orderNumber = this.item?.orderNumber || 'this order';
                this.confirmationService.confirm({
                    message: `Are you sure you want to sync order ${orderNumber} to M3?`,
                    header: 'Confirm Sync to M3',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.syncToM3();
                    }
                });
            },
            error: (err) => {
                this.loaderService.hide();
                const msg =
                    typeof err.error === 'string'
                        ? err.error
                        : err.error?.message || 'Could not verify customer block status in M3.';
                this.messageService.add({
                    severity: 'error',
                    summary: 'Customer Check Failed',
                    detail: msg,
                    life: 5000
                });
            }
        });
    }
        alreadySyncedDialogVisible: boolean = false;
        alreadySyncedDialogMessage: string = '';
        customerBlockedDialogVisible: boolean = false;
        customerBlockedDialogMessage: string = '';
    syncToM3() {
        if (!this.item?.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Order number is required.'
            });
            return;
        }
        this.loaderService.show('Syncing order to M3...', 'Please wait...');
        this.productService
            .syncSingleOrderToM3(this.item.orderNumber, 'CustomerOrder')
            .subscribe({
                next: () => {
                    this.loaderService.hide();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Sync Completed',
                        detail: `Order ${this.item.orderNumber} synced to M3 successfully. Invoice will appear in the invoice column.`,
                        life: 4000
                    });
                    this.skipReleaseLock = false;
                    this.router.navigate(['/Orders1']);
                },
                error: (err) => {
                    this.loaderService.hide();
                    const apiErrorCode = err?.error?.errorCode;
                    const apiMessage = err?.error?.message || '';
                    const isAlreadySyncedError = apiErrorCode === 'ORDER_ALREADY_SYNCED' || /already\s+synced/i.test(apiMessage);
                    if (isAlreadySyncedError) {
                        this.alreadySyncedDialogMessage = apiMessage || 'Order is already synced with Infor M3';
                        this.alreadySyncedDialogVisible = true;
                        setTimeout(() => {
                            this.alreadySyncedDialogVisible = false;
                            this.skipReleaseLock = false;
                           this.router.navigate(['/Orders1']);
                     }, 4000);
                       return;
                   }
                    if (apiErrorCode === 'CUSTOMER_BLOCKED') {
                        this.customerBlockedDialogMessage =
                            apiMessage || 'Customer is blocked in M3. Sync is not allowed until the customer block is cleared.';
                        this.customerBlockedDialogVisible = true;
                        return;
                    }
                    const isConflict = err?.status === 409 || err?.status === 423;
                    this.messageService.add({
                        severity: isConflict ? 'warn' : 'error',
                        summary: isConflict ? 'Sync In Progress' : 'Sync Failed',
                        detail: err?.error?.message || (isConflict ? 'Syncing in progress, please try later.' : 'Failed to sync order to M3.'),
                        life: 4000
                    });
                }
            });
    }

    getLabel(key: string): string {
        return this.labels[this.selectedLanguage][key] || key;
    }

    getAddressLines(address: string): string[] {
        return address
            ? address
                  .split('|')
                  .map((line) => line.trim())
                  .filter((line) => line)
            : [];
    }

    // getPhoneLines(phone: string): string[] {
    //     return phone
    //         ? phone.split('|').map((line) => line.trim()).filter((line) => line)
    //         : [];
    // }

    startLockRefresh() {
        this.refreshOrderLock(); // Call once immediately
        this.lockRefreshInterval = setInterval(() => {
            this.refreshOrderLock();
        }, 30 * 1000); // 30 seconds
    }

    refreshOrderLock() {
        const orderNumber = this.item?.orderNumber;
        const companyId = this.userService.getCompanyId() || '';
        const divisionId = this.userService.getDivisionId() || '';
        const currentUsername = this.userService.getUserName?.() || 'unknown';

        if (orderNumber && companyId && divisionId && currentUsername) {
            const url = `${environment.apiUrl}orders/lock/lockrefresh?orderNumber=${orderNumber}&companyId=${companyId}&divisionId=${divisionId}&currentUsername=${currentUsername}`;

            // const url = `http://192.168.31.92:8444/orders/lock/lockrefresh?orderNumber=${orderNumber}&companyId=${companyId}&divisionId=${divisionId}&currentUsername=${currentUsername}`;
            this.http.post(url, {}).subscribe({
                next: () => console.log('Order lock refreshed (picking list)'),
                error: () => console.warn('Order lock refresh failed (picking list)')
            });
        }
    }

    releaseOrderLock() {
        const orderNumber = this.item?.orderNumber;
        const companyId = this.userService.getCompanyId() || '';
        const divisionId = this.userService.getDivisionId() || '';
        const currentUsername = this.userService.getUserName?.() || 'unknown';

        if (orderNumber && companyId && divisionId && currentUsername) {
            const url = `${environment.apiUrl}orders/lock/release?orderNumber=${orderNumber}&companyId=${companyId}&divisionId=${divisionId}&currentUsername=${currentUsername}`;

            // const url = `http://192.168.31.92:8444/orders/lock/release?orderNumber=${orderNumber}&companyId=${companyId}&divisionId=${divisionId}&currentUsername=${currentUsername}`;
            this.http.post(url, {}).subscribe({
                next: () => console.log('Order lock released (picking list)'),
                error: () => console.warn('Order lock release failed (picking list)')
            });
        }
    }

    getPhoneLines(phone: string): string[] {
        return phone
            ? phone
                  .split('|')
                  .map((line) => line.trim())
                  .filter((line) => line)
            : [];
    }
    // Add in ngOnDestroy
    ngOnDestroy() {
        console.log('Component destroyed, releasing order lock');

        if (this.invoiceInProgressIntervalId != null) {
            clearInterval(this.invoiceInProgressIntervalId);
            this.invoiceInProgressIntervalId = null;
        }

        this.revokeInvoiceObjectUrl();

        // Do not release lock when navigating to order (Go to Order) so user keeps editing
        if (!this.skipReleaseLock) {
            this.releaseOrderLock();
        }

        clearInterval(this.lockRefreshInterval);
    }
}
